import React from "react";
import { DashboardOverview } from "../../../lib/api";
import { formatNumber } from "./format";
import { MobileCard, SectionHeader } from "./section";

const InventoryBreakdownCard: React.FC<{ inventory?: DashboardOverview["inventory"] }> = ({
  inventory,
}) => {
  const segments = [
    { label: "Available", value: inventory?.totalAvailable ?? 0, color: "#53A9FB" },
    { label: "On rent", value: inventory?.totalRented ?? 0, color: "#A78BFA" },
    { label: "Reserved", value: inventory?.totalReserved ?? 0, color: "#FBBF24" },
    { label: "Damaged", value: inventory?.totalDamaged ?? 0, color: "#F87171" },
    { label: "Lost", value: inventory?.totalLost ?? 0, color: "#9CA3AF" },
  ];
  const total = segments.reduce((sum, segment) => sum + segment.value, 0);
  const percentOf = (value: number) => (total > 0 ? (value / total) * 100 : 0);

  return (
    <section>
      <SectionHeader
        title="Inventory status"
        subtitle={`${formatNumber(total)} items in total`}
        actionLabel="Inventory"
        actionHref="/inventory"
      />
      <MobileCard>
        <div className="flex h-3 w-full overflow-hidden rounded-full bg-gray-100">
          {segments.map((segment) =>
            segment.value > 0 ? (
              <span
                key={segment.label}
                className="h-full transition-[width] duration-700 ease-out first:rounded-l-full last:rounded-r-full"
                style={{ width: `${percentOf(segment.value)}%`, backgroundColor: segment.color }}
              />
            ) : null,
          )}
        </div>

        <ul className="mt-4 divide-y divide-gray-50">
          {segments.map((segment) => (
            <li key={segment.label} className="flex items-center gap-3 py-2.5">
              <span
                className="h-2.5 w-2.5 shrink-0 rounded-full"
                style={{ backgroundColor: segment.color }}
              />
              <span className="flex-1 text-sm text-gray-700">{segment.label}</span>
              <span className="text-sm font-semibold text-gray-900">
                {formatNumber(segment.value)}
              </span>
              <span className="w-12 text-right text-xs text-gray-400">
                {percentOf(segment.value).toFixed(percentOf(segment.value) < 10 ? 1 : 0)}%
              </span>
            </li>
          ))}
        </ul>
      </MobileCard>
    </section>
  );
};

export default InventoryBreakdownCard;
